import React from "react";
import { TaskBar } from "@react95/core";

function Taskbar() {
  return <TaskBar />;
}

export default Taskbar;
